import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取fba列表
export const getFbaList = params => {
  return axios.request({
    url: "/warehouse/fba/index",
    method: "get",
    params
  });
};

//获取fba详情
export const getFbaDetail = id => {
  return axios.request({
    url: "/warehouse/fba/details/" + id,
    method: "get"
  });
};

// 获取仓库
export const getFbaWarehouse = params => {
  return axios.request({
    url: "/warehouse/fba/warehouse",
    method: "get",
    params
  });
};

// 上传fba文件
export const addFile = data => {
  return axios.request({
    url: "/warehouse/fba/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};

// 添加备注
export const addRemark = data => {
  return axios.request({
    url: "/warehouse/fba/remarks/" + data.id,
    method: "post",
    data
  });
};

// 导出
export const exportFba = data => {
  return axios.request({
    url: "/warehouse/fba/export",
    method: "post",
    data
  });
};

// 预览
export const previewFba = id => {
  return axios.request({
    url: "/warehouse/fba/preView/" + id,
    method: "get"
  });
};

export const del = id => {
  return axios.request({
    url: "/warehouse/fba/delete/"+id,
    method: "post",
  });
};
